import React from 'react';
import type { ITextElement, Token } from '@basis-theory/react-elements';

import { type OnboardingState } from './onboardingReducer';
import {
  BasisTheoryTextElement,
  OnboardingDropdown,
  OnboardingToggle,
} from './SharedUI';

const OWNERSHIP_TYPE_OPTIONS = [
  { value: 'sole_proprietorship', label: 'Sole Proprietorship' },
  { value: 'partnership', label: 'Partnership' },
  { value: 'llc', label: 'LLC' },
  { value: 'corporation', label: 'Corporation' },
  { value: 's_corporation', label: 'S Corporation' },
  { value: 'nonprofit', label: 'Nonprofit' },
];

type IncorporationViewProps = {
  onboardingState: OnboardingState;
  setOnboardingField: (
    stateKey: string,
    value: string | string[] | boolean
  ) => void;
  token: Token | null;
  updateToken: (id: string, ref: React.RefObject<ITextElement>) => void;
  isDarkMode: boolean;
};

export const IncorporationView = ({
  onboardingState,
  setOnboardingField,
  token,
  updateToken,
  isDarkMode,
}: IncorporationViewProps) => (
  <div className="flex flex-col h-fit gap-y-f2">
    <BasisTheoryTextElement
      id="businessEin"
      label="Employer Identification Number (EIN)"
      token={token}
      update={updateToken}
      isDarkMode={isDarkMode}
    />
    <BasisTheoryTextElement
      id="businessStateOfIncorporation"
      label="State of Incorporation"
      token={token}
      update={updateToken}
      isDarkMode={isDarkMode}
    />
    <BasisTheoryTextElement
      id="businessYearIncorporated"
      label="Year of Incorporation"
      token={token}
      update={updateToken}
      isDarkMode={isDarkMode}
    />
    <OnboardingDropdown
      stateKey="businessOwnershipType"
      label="Ownership Type"
      options={OWNERSHIP_TYPE_OPTIONS}
      state={onboardingState}
      setField={setOnboardingField}
    />
    <OnboardingToggle
      label="Has your company undergone any significant changes to its legal structure, ownership (>25%), name, or jurisdiction of incorporation in the past 24 months?"
      stateKey="businessHasUndergoneChanges"
      state={onboardingState}
      setField={setOnboardingField}
    />
  </div>
);
